import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MessagesList extends Component {
    constructor(props) {
        super(props);
        this.props = props
    }

    componentWillReceiveProps(props) {
        if(props.activeChannel === this.props.channel) {
            this.props.getMessages()
        }
    }

    componentDidUpdate(){
        this.scrollChatToBottom() 
    }

    render() {
        return (
            <div className="message-list">
                {
                    this.props.channel && this.props.messages.map((item, key) => (
                        <div className={item.author == localStorage.getItem('uid') ? 'message-sent' : 'message-received'} key={key}>
                            <p>{item.body}</p>
                        </div>
                    ))}
                    <div ref="scroller"></div>
            </div>
        )
    }

    scrollChatToBottom() {
        this.refs.scroller.scrollIntoView({ behavior: "instant" }) 
    }
}

MessagesList.propTypes = {
    history: PropTypes.object,
    channel: PropTypes.object,
    messages: PropTypes.array,
    activeChannel: PropTypes.object,
    getMessages: PropTypes.func,
};
export default MessagesList;


// WEBPACK FOOTER //
// ./src/view/messagesList.js